import { Navigate, Route, Routes } from "react-router-dom";

import { SIGNED_OUT_PATH } from "./auth/SessionProvider";
import { AppShell } from "./components/layout/AppShell";
import { AccountPage } from "./pages/AccountPage";
import { AccountsPage } from "./pages/AccountsPage";
import { AdminPage } from "./pages/AdminPage";
import { DatasetPage } from "./pages/DatasetPage";
import { NewDatasetPage } from "./pages/NewDatasetPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ReadsPage } from "./pages/ReadsPage";
import { ReceiptPage } from "./pages/ReceiptPage";

/** Route table: the catalogue first, adding a dataset second. */
export function App(): JSX.Element {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<AccountsPage />} />
        {/* The screen the whole product is judged on. */}
        <Route path="/new" element={<NewDatasetPage />} />
        <Route path="/datasets/:id" element={<DatasetPage />} />
        {/* Every read of this client's data, granted and refused. */}
        <Route path="/datasets/:id/reads" element={<ReadsPage />} />
        {/* Printable, server-authored, the page a client is forwarded. */}
        <Route path="/datasets/:id/receipt" element={<ReceiptPage />} />
        <Route path="/account" element={<AccountPage />} />
        {/* Approving people, watching the storage, the emergency stop. */}
        <Route path="/admin" element={<AdminPage />} />
        {/* Where a failed sign-in lands. Reaching it *with* a session means
            the session was repaired in the meantime — go to the console. */}
        <Route path={SIGNED_OUT_PATH} element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
